const getTargetOffer = (mbox) => {

    return new Promise((resolve) => {

        adobe.target.getOffer({
            'mbox': mbox,
            'success': (offer) => (
                resolve(offer)
            ),
            'error': (status, error) => (
                resolve([])
            ),
        });

    });

};

const getAdobeTarget = async(config = {}) => {

    let offer = [];
    const adobeEnabled = (
        config.enabled
        && typeof window.adobe !== 'undefined'
        && window.adobe.target
        && window.adobe.target.getOffer
    );

    if (adobeEnabled) {

        const mbox = config.mbox ?? 'target-global-mbox';
        offer = await getTargetOffer(mbox);

    }

    return offer;

};

export default getAdobeTarget;
